import React from 'react';

import { LOOKER_DASHBOARDS } from '../constants';
import { LookerPage } from './injectable-display';

export const ProfitabilityOptimization = () => {
  return <LookerPage dashboardId={LOOKER_DASHBOARDS.profitabilityOptimization} />;
};
